/**
 * The dashboard's own path, and the segment every module lives under:
 * `/modules` lists them, `/modules/<id>` opens one.
 *
 * Nesting is what puts "Modules" in the breadcrumb between the application and
 * the module. The trail is read off the activated routes, so a module is a step
 * below the list it was picked from only if it is a step below it in the router
 * too.
 */
export const MODULE_ROUTE_PREFIX = 'modules';

/**
 * The segment of the "no licence" page: `/modules/no-licence/<id>`. Where a module the viewer is
 * not licensed for leads, instead of a silent bounce to the dashboard. No module claims this id.
 */
export const NO_LICENCE_SEGMENT = 'no-licence';

/** The address that explains why a module is withheld and where to get the licence. */
export function noLicenceUrl(moduleId: string): string[] {
  return ['/', MODULE_ROUTE_PREFIX, NO_LICENCE_SEGMENT, moduleId];
}

/** The module a URL points into, or `undefined` on the shell's own screens. */
export function moduleIdFromUrl(url: string): string | undefined {
  const [, prefix, id] = url.split(/[?#]/)[0].split('/');

  return prefix === MODULE_ROUTE_PREFIX && id ? decodeURIComponent(id) : undefined;
}
